import React, { useId } from 'react';
import { ToggleSwitchStyle } from './Switch.styles';

const Switch = ({ value, label, className, ...props }) => {
  const autoId = useId();
  const switchId = label || autoId;

  return (
    <>
      <ToggleSwitchStyle>
        {label && (
          <label className="checkbox-label-title" htmlFor={switchId}>
            {label}
          </label>
        )}

        <input
          type="checkbox"
          checked={value}
          onChange={({ target: { checked } }) => {
            props.onChange?.({
              target: { value: checked },
            });
          }}
          id={switchId}
        />
        <label className="switch" htmlFor={switchId}></label>
      </ToggleSwitchStyle>
    </>
  );
};

export default Switch;
